import { render, staticRenderFns } from "./WebhooksEdit.vue?vue&type=template&id=a709be56"
import script from "./WebhooksEdit.vue?vue&type=script&lang=js"
export * from "./WebhooksEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports